export class ChartNewInactiveClientsData {
  public constructor (
    readonly year: number,
    readonly month: number,
    readonly neu: number,
    readonly sum: number,
  ) {}

  static createListFromResponse (data: any): Array<ChartNewInactiveClientsData> {
    return data.map((item: any) => {
      return new ChartNewInactiveClientsData(
        item.Jahr,
        item.Monat,
        item.Neu,
        item.Anzahl
      )
    })
  }
}
